import { render, staticRenderFns } from "./EducationalCategories.vue?vue&type=template&id=501f852e&"
import script from "./EducationalCategories.vue?vue&type=script&lang=js&"
export * from "./EducationalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports